<template>
  <div justify="center" class="certificate">
    <v-dialog
      v-model="dialog"
      fullscreen
      scrollable
      hide-overlay
      persistent
      class="dialogCertificate overflow-y-hidden"
    >
    <v-card style="background-color: #1A1C1D">
      <v-toolbar
        dark
        color="#103362"
        max-height="96%"
        style="border-radius: 0px;"
      >
        <v-toolbar-title class="pl-3 w-700 font-32">
          ใบรับรองแพทย์
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn
          depressed
          color="#3576CB"
          height="48"
          @click="openApprove()"
          :disabled=" !(loading == false && 'result' in pdfImage) || approve_status == true"
        >
          อนุมัติเอกสาร
        </v-btn>
        <v-btn
          class="mx-2"
          text
          color="#103362"
          @click="closeDialog"
        >
          <img
            height="14"
            width="14"
            :src="require('@/assets/icon/x_white.png')"
          />
        </v-btn>

        <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
   
      ></v-progress-linear>
        
      </v-toolbar>
      <v-card-text style="height: 100%;">
        <div class="PDFsize" v-if="loading == false && 'result' in pdfImage" >
          <pdf :src="'data:application/pdf;base64,' + pdfImage.result"></pdf>
        </div>
        <div v-else-if="loading == false" style="text-align:center; padding-top: 38vh">
            <span class="text-white font-36 noselect"> ไม่พบใบรับรองแพทย์</span>
        </div>
      </v-card-text>
      
    </v-card>
    </v-dialog>


    <v-dialog
      v-model="dialogApprove"
      max-width="568"
      persistent
      hide-overlay
    >
      <v-card
        class="mx-auto"
        color="#ffffff"
        max-width="568"
      >
        <v-card-title class="pb-0">
          <span class="w-500 font-24">ลงนามอนุมัติ</span>
          <v-spacer></v-spacer>
          <v-avatar size="24px">
            <v-img
              width="30px"
              height="30px"
              :src="require('@/assets/icon/x.png')"
              alt="x"
              @click="closeDialogApprove"
            />
          </v-avatar>
          
        </v-card-title>
        <v-card-title class="pt-0">
          <v-divider></v-divider>
        </v-card-title>
        
        <v-card-text>
          <div v-show="signDefault == 'default'" class="signature" style="height: 200px">
            <div v-if="signpadFrom != ''">
              <v-img
                width="100%"
                height="100%"
                :src="'data:image/png;base64,'+ signpadFrom"
              />
            </div>
            <div v-else style="padding-top: 10vh; text-align: center">
              <span class="font-24 noselect" style="cursor:default">ยังไม่มีการบันทึกลายเซ็น</span>
            </div>
          </div>
          <div v-show="signDefault == 'signPad'">
            <VueSignaturePad
              id="signature"
              width="100%"
              height="200px"
              ref="signaturePad"
              :options="{
                onBegin: () => {
                  $refs.signaturePad.resizeCanvas();
                },
              }"
            />
          </div>
          
          <v-row>
            <v-col cols="8" align-self="center">
              <v-radio-group
                v-model="signDefault"
                row
              >
                <v-radio
                  label="Default"
                  value="default"
                ></v-radio>
                <v-radio
                  label="Sign Pad"
                  value="signPad"
                ></v-radio>
                
              </v-radio-group>
            </v-col>
            <v-col cols="4" align-self="center" class="text-align-end" >
              <v-btn
                width="86"
                
                color="#FF8082"
                
                :disabled="signDefault == 'default'"
                @click="clear()"
              >
                <v-img
                  :src="require('@/assets/icon/Trash_w.png')"
                  style="max-hight:20px; max-width:20px"
                />
                <span class="text-white">ล้างค่า</span>
                
              </v-btn>
            </v-col>
          </v-row>     
        </v-card-text>
        

        
        <v-card-actions>
          <v-row class="pa-0 ma-0 pb-3 pr-2">
            <v-col class="pr-0 py-0">
              <v-btn
                block
                color="#3576CB"
                dark
                @click="approve"
              >
                ลงนามอนุมัติ
              </v-btn>
            </v-col>
          </v-row>
          
        </v-card-actions>
        
      </v-card>
      
    </v-dialog>

     

  </div>

  
</template>

<script>
import pdf from 'vue-pdf-signature'
// import { mapGetters } from "vuex";
export default {
  components: {
    pdf
  },
  // ...mapGetters({
  //     medicalCertificatePDF: "setMedicalCertificatePDFGetter" || {},
  //   }),

  data() {
    return {
      ItemDiagnosticHistories: '',
      documentApprove: false,
      dialog: false,
      loading: false,
      dialogApprove: false,
      pdfImage:{},
      options: {
        penColor: "#4d00ff",
      },
      signDefaultLook: true,
      signDefault: 'default',
      signpadFrom: '',
      access_token_test: '',
      approve_status:false,
      approve_pdfImage: {},
      // signpadFrom: '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'
    }
  },

  watch: {
    loading (val) {
      if (!val) return
      setTimeout(() => (this.loading = false), 10000)
    },
  },

  methods: {
    openDialog(item) {
      this.getMedicalCertificatePDF(item);
      this.dialog = true;
      this.loading = true;
      this.ItemDiagnosticHistories = item;
      this.documentApprove = false;
    },

    closeDialog() {
      this.dialog = false;
      if ('result' in this.pdfImage) {
        const close = {
          _id: this.ItemDiagnosticHistories,
          documentApprove: this.documentApprove,
          pdfImage: this.pdfImage.result,
        }
        this.$emit("close", close);
      }
      
    },


    async openApprove() {
      this.dialogApprove = true;
      // get_access_token_test 
      this.access_token_test = ''
      await this.axios.post(`https://testoneid.inet.co.th/api/oauth/getpwd`,
        {
          grant_type: "password",
          client_id: "139",
          client_secret: "ePmB67BjhE8qKrLW2eFCSQXi175EKHqF2nmFx092",
          username: "testt001",
          password: "test1234"
        },
      )
      .then((res) => {
        const { data = {} } = res;
        this.access_token_test = data.access_token
      });
      this.getsignDefault();
    },

    closeDialogApprove() {
      this.dialogApprove = false;
      this.clear();
    },
     
    async getsignDefault() {
      try {
        await this.axios
        .get(
          process.env.VUE_APP_BASE_URL +
            `/medcer/url-sign`,
            {
              headers: { 'Content-Type': "application/json; chaerset=utf-8", Authorization: `Bearer ${sessionStorage.one_access_token}` },
            }
        )
        .then(async (res) => {
          await this.$store.dispatch("actionLog", {
            action: "sing medcer",
            action_by: sessionStorage.account_id,
            path: `/medcer/url-sign`,
            header: { 'Content-Type': "application/json; chaerset=utf-8", Authorization: `Bearer ${sessionStorage.one_access_token}` }
          });
          const { data = {} } = res;
          if(data.image.length != 0) {
            this.signpadFrom = data
          } else {
            this.signpadFrom = ''
          }
        });
      } catch (err) {
        this.signpadFrom = ''
      }
    },

    async approve() {
      var signa = '';
      if(this.signDefault == 'default') {
        signa =  this.signpadFrom
      } else if (this.signDefault == 'signPad') {
        const { data } = this.$refs.signaturePad.saveSignature();
        if (data != '' && data != undefined) {
          signa =  (data.split("data:image/png;base64,")[1]);
        } else {
          signa = ''
        }
      }
      this.documentApprove = true
      if (signa !== '') {
        const sendSet = {
          id: this.ItemDiagnosticHistories,
          doc_type: "ใบรับรองแพทย์",
          sign: signa,
          base64_pdf: this.pdfImage.result
        }
        this.loading = true;
        this.dialogApprove = false;
        await this.axios.post(process.env.VUE_APP_BASE_URL + `/medcer/paper-sign`, sendSet ,
            {
              headers: { 'Content-Type': "application/json; chaerset=utf-8", Authorization: `Bearer ${sessionStorage.one_access_token}` },
              // headers: { 'Content-Type': "application/json; chaerset=utf-8", Authorization: `Bearer ${this.access_token_test}` },
            }
        )
        .then(async (res) => {
          await this.$store.dispatch("actionLog", {
            action: "paper sing medcer",
            action_by: sessionStorage.account_id,
            path: `/medcer/paper-sign`,
            header: { 'Content-Type': "application/json; chaerset=utf-8", Authorization: `Bearer ${sessionStorage.one_access_token}` },
            body: sendSet
          });
          const { data = {} } = res;
          this.approve_status = true,
          this.documentApprove = true,
          this.pdfImage = {}
          this.pdfImage = data,
          setTimeout(() => (this.loading = false, this.clear()), 5000)
        })
        .catch(error => {
          const { data = {} } = error.response;
            this.$swal({
            type: "error",
            width: "430",
            imageUrl: `${require("@/assets/icon/vcsconflicting_93497.png")}`,
            imageWidth: 80,
            title: `${data.message}`,
            showCloseButton: false,
            showConfirmButton: false,
            background: "white",
            position: "center",
            timer: 3000,
            backdrop: false,
          });
        });
      }

      

      
    },

    clear() {
      this.$refs.signaturePad.clearSignature();
    },

    async getMedicalCertificatePDF(id) {
      const params = new URLSearchParams();
      params.append("id", id);
      await this.axios
        .get(
          process.env.VUE_APP_BASE_URL +
            `/medcer/form-pdf?${params}`,
            {
              headers: { 'Content-Type': "application/json; chaerset=utf-8", Authorization: `Bearer ${sessionStorage.one_access_token}` },
              // headers: {  'Content-Type': "application/json; chaerset=utf-8", Authorization: `Bearer ${token}` },
            }
        )
        .then(async (res) => {
          await this.$store.dispatch("actionLog", {
            action: "get form pdfr",
            action_by: sessionStorage.account_id,
            path: `/medcer/form-pdf`,
            params: {
              id: id
            },
            header: { 'Content-Type': "application/json; chaerset=utf-8", Authorization: `Bearer ${sessionStorage.one_access_token}` }
          });
          const { data = {} } = res;
          this.pdfImage = data
          // this.downloadPDF(data.result)
          setTimeout(() => (this.loading = false), 2000)
        });
    },

  }

}

</script>

<style scope>
#signature {
  border: 1px solid #BABDBF;
  border-radius: 5px;
  /* background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274); */
  /* background-image: #BABDBF; */
  background-origin: border-box;
  background-clip: content-box, border-box;
}
.signature {
  border: 1px solid #BABDBF;
  border-radius: 5px;
  /* background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274); */
  /* background-image: #BABDBF; */
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: "100%";
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}

.PDFsize {
  padding-top: 5%;
  padding-left: 15%;
  padding-right: 15%;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
  supported by Chrome, Edge, Opera and Firefox */
}

/* .overflow-y-hidden.html {
  box-sizing: border-box;
  overflow-y: hidden !important;
  -webkit-text-size-adjust: 100%;
  word-break: normal;
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
} */
/* ::-webkit-scrollbar{
  display: none;
} */

/* html.overflow-y-hidden {
    overflow-y: hidden!important;
} */

.overflow-y-hidden{
  height: calc(100vh - 200px) !important;
}



</style>